import { HomeTabType } from '@/core/presenter/viewModel/viewTypes';
import clsx from 'clsx';
import ActivityItem from './ActivityItem';
import * as ViewModel from '@/core/presenter/viewModel';
import NoActivityData from './NoActivityData';
import { MAX_TRANSACTION_ITEMS } from '@/consts';
import ActivityItemInfo from './ActivityItemInfo';

interface ActivityAreaProps {
  activeTab: HomeTabType;
  activities: ViewModel.IResponseActivity[];
  isNotActivities: boolean;
  onClickPrevTransactionBtn: () => void;
}

const ActivityArea = ({
  activeTab,
  activities,
  isNotActivities,
  onClickPrevTransactionBtn,
}: ActivityAreaProps): JSX.Element => {
  return (
    <>
      {isNotActivities && (
        <div className="no-activity">
          <NoActivityData />
        </div>
      )}
      {!isNotActivities && (
        <div
          className={clsx('activity-area', {
            show_important: activeTab === HomeTabType.ACTIVITIES,
          })}
        >
          <ul className="list">
            {activities.slice(0, MAX_TRANSACTION_ITEMS).map((activity, index) => (
              <ActivityItem key={index} activity={activity} />
            ))}
            <ActivityItemInfo onClickPrevTransactionBtn={onClickPrevTransactionBtn} />
          </ul>
        </div>
      )}
    </>
  );
};

export default ActivityArea;
